import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const roomsApi = createApi({
  reducerPath: 'roomsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getRooms: builder.query({
      query() {
        return {
          url: `${urls.rooms}`,
          method: 'GET',
        };
      },
    }),
    getRoomsForReservation: builder.query({
      query() {
        return {
          url: `${urls.roomsForReservation}`,
          method: 'GET',
        };
      },
    }),
    getRoomsForPublicReservation: builder.query({
      query() {
        return {
          url: `${urls.roomsForPublicReservations}`,
          method: 'GET',
        };
      },
    }),
    getRoomDetail: builder.query({
      query(id) {
        return {
          url: urls.roomDetail(id),
          method: 'GET',
        };
      },
    }),
    saveRoom: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.roomDetail(req.id),
            method: 'PUT',
            data: req.data,
          };
        } else {
          return {
            url: urls.rooms,
            method: 'POST',
            data: req.data,
          };
        }
      },
    }),
    deleteRoom: builder.mutation({
      query(id) {
        return {
          url: urls.roomDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetRoomsQuery,
  useGetRoomsForReservationQuery,
  useGetRoomsForPublicReservationQuery,
  useGetRoomDetailQuery,
  useSaveRoomMutation,
  useDeleteRoomMutation,
} = roomsApi;
